// extracted by mini-css-extract-plugin
export default {"wrapper":"YellowBox-module__wrapper___PC_19","newWrapper":"YellowBox-module__newWrapper___NuKSk","wrapperShadow":"YellowBox-module__wrapperShadow___QQr2l"};